<template>
  <label :for="id" class="v-toggle" :class="{ disabled: disabled }">
    <input
      @change="onChange($event)"
      type="checkbox"
      :disabled="disabled"
      :id="id"
      :checked="checked"
    />
    <span class="toggle">
      <span class="handle"></span>
    </span>
    {{label}}
  </label>
</template>

<script>
export default {
  name: "v-toggle",
  props: {
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    checked: { type: Boolean, default: false }
  },
  data() {
    return {
      id: null
    };
  },
  methods: {
    onChange(e) {
      this.$emit("input", !this.checked);
      this.$emit("change", !this.checked);
    }
  },
  mounted() {
    this.id = this._uid;
  }
};
</script>

<style scoped lang="scss">
@import "../../design/variables.scss";

.v-toggle {
  display: inline-flex;
  position: relative;
  height: 25px;
  padding-left: 48px;
  cursor: pointer;
  user-select: none;

  &.disabled {
    cursor: no-drop;
  }

  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline;
    border: 0;
    opacity: 0;
    width: 0;
    height: 0;
    &:focus {
      & + .toggle {
        & .handle {
          box-shadow: 0 0 2px #000;
        }
      }
    }
    &:checked {
      & + .toggle {
        background: map-deep-get($colors, "ornament", "highlight");
        & .handle {
          transform: translateX(15px);
        }
      }
    }
  }

  .toggle {
    background-color: #fff;
    transition: background 300ms cubic-bezier(0.23, 1, 0.32, 1);
    border: 1px solid map-deep-get($colors, "ornament", "border");
    border-radius: 45px;
    position: absolute;
    width: 40px;
    top: 0;
    bottom: 0;
    left: 0;
    .handle {
      transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1);
      display: block;
      position: absolute;
      border-radius: 50%;
      background-color: #fff;
      border: 1px solid map-deep-get($colors, "ornament", "border");
      box-shadow: 0px 0px 1px inset
        map-deep-get($colors, "foreground", "secondary");
      height: 19px;
      width: 19px;
      left: 2px;
      bottom: 2px;
    }
  }
}
</style>
